export default {
	title: "Lean Customs - Poruszaj się po odprawach celnych z łatwością",
	description:
		"Zaufaj Lean Customs we wszystkich swoich deklaracjach celnych, cyfrowo, szybko i precyzyjnie",
	nav: {
		services: "Usługi",
		software: "Oprogramowanie",
		about: "O nas",
		contact: "Kontakt",
		"hs-codes": "Kody HS",
		"duty-calc": "Kalkulator opłat celnych",
		docs: "Dokumenty",
		blog: "Blog",
		login: "Zaloguj się - kontrakty",
		orders: "Zamówienia",
		cta: "Rozpocznij",
	},
	hero: {
		title: "Poruszaj się po odprawach celnych z łatwością",
		subtitle:
			"Zaufaj Lean Customs we wszystkich swoich deklaracjach celnych, cyfrowo, szybko i precyzyjnie",
		cta: "Rozpocznij",
	},
	features: {
		one: {
			title: "Oprogramowanie celne",
			subtitle: "Odkryj naszą innowacyjną aplikację do wszystkich potrzeb celnych",
		},
		two: {
			title: "Nasze usługi",
			subtitle: "Import, Export, Tranzyt, Reprezentacja fiskalna i Certyfikaty",
		},
		three: {
			title: "Co robimy",
			subtitle: "Ponad €3 miliardy wartości towarów zadeklarowanych - nasza historia",
		},
	},
	cta: {
		title: "Importer, Eksporter, Spedytor lub Agent celny",
		subtitle: "Lean Customs ma dla Ciebie rozwiązanie. Dołącz do naszej społeczności.",
		cta: "Rozpocznij",
	},
	codeSearch: {
		title: "Wyszukiwanie kodów HS",
		subtitle:
			"Wyszukuj kody HS błyskawicznie z pełnotekstowym wyszukiwaniem i uzyskaj najnowsze dane",
		cta: "Szukaj teraz",
		ctaNote: "(To jest darmowe!)",
	},
	dutyCalculator: {
		title: "Kalkulator opłat celnych",
		subtitle: "Oblicz swoje opłaty celne i podatki za pomocą naszego łatwego w użyciu kalkulatora",
		cta: "Oblicz teraz",
		ctaNote: "(Również darmowe!)",
	},
	services: {
		title: "Usługi",
		description:
			"Lean Customs oferuje szeroki zakres usług, które pomogą Ci poruszać się po odprawach celnych z łatwością. Możemy pomóc Ci z importem, eksportem, tranzytem, reprezentacją fiskalną i certyfikatami.",
		more: "Dowiedz się więcej",
		content: {
			import: {
				title: "Import (IMA)",
				subtitle:
					"Lean Customs zapewnia, że używasz właściwej wartości celnej i składasz swoją deklarację z odpowiednią klasyfikacją. Każda deklaracja jest przedstawiana do zatwierdzenia importerowi przed złożeniem jej do odprawy celnej.",
			},
			fiscal: {
				title: "Reprezentacja fiskalna (BFV)",
				subtitle:
					"Lean Customs posiada licencję na pełnienie ograniczonej reprezentacji fiskalnej.<br><br>To pomaga ograniczyć administrację VAT dla firm spoza Holandii handlujących przez lub za pośrednictwem terytorium Holandii.",
			},
			certificates: {
				title: "Certyfikaty",
				subtitle:
					"Lean Customs może uzyskać dla Ciebie następujące certyfikaty:<br>T2L, ATR (Turcja)",
			},
			export: {
				title: "Eksport (EXA)",
				subtitle:
					"Dokumentacja eksportowa jest obowiązkowym wymogiem przy sprzedaży poza Unię Europejską.<br><br>Lean Customs zapewnia terminowe przetwarzanie dokumentów i automatycznie powiadamia, jeśli dokument nie został odprawiony.",
			},
			transit: {
				title: "Tranzyt (T1)",
				subtitle:
					"Dokumenty tranzytowe pozwalają na transport towarów w obrębie Unii Europejskiej bez konieczności składania deklaracji importowej.",
			},
			automation: {
				title: "Automatyzacja",
				subtitle:
					"Buduj zautomatyzowane przepływy deklaracji razem z Lean Customs i miej kontrolę nad swoimi sprawami celnymi.<br>SAP, Exact, Afas, MS Dynamics, Oracle",
			},
		},
	},
	comingSoon: {
		title: "Wkrótce dostępne",
		subtitle: "Ciężko nad tym pracujemy, wróć wkrótce!",
	},
};
